import { ProviderStatus } from '@/lib-backend';

export type ProviderStatusSeverity = 'success' | 'warn' | 'danger' | 'secondary' | 'info';

export interface ProviderStatusView {
    label: string;
    severity: ProviderStatusSeverity;
    description: string;
    icon: string;
}

export function providerStatusView(status: ProviderStatus | null): ProviderStatusView {
    switch (status) {
        case ProviderStatus.Ok:
            return {
                label: 'Active',
                severity: 'success',
                description: 'Realm is registered and active on the game server.',
                icon: 'pi pi-check-circle',
            };
        case ProviderStatus.Inactive:
            return {
                label: 'Inactive',
                severity: 'warn',
                description: 'Realm exists on the game server but is currently inactive.',
                icon: 'pi pi-pause-circle',
            };
        case ProviderStatus.NotConfigured:
            return {
                label: 'Not configured',
                severity: 'danger',
                description:
                    'Realm is not registered on the game server. Players will not be able to play games until you sync.',
                icon: 'pi pi-exclamation-triangle',
            };
        case ProviderStatus.Unavailable:
            return {
                label: 'Unavailable',
                severity: 'secondary',
                description: 'Could not check status — the game server was unreachable.',
                icon: 'pi pi-cloud-off',
            };
        case ProviderStatus.None:
            return {
                label: 'Not applicable',
                severity: 'info',
                description: 'Game server integration is not applicable for this realm.',
                icon: 'pi pi-minus-circle',
            };
        case ProviderStatus.Unknown:
        case null:
        default:
            return {
                label: 'Unknown',
                severity: 'secondary',
                description: 'Status is unknown.',
                icon: 'pi pi-question-circle',
            };
    }
}
